"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOLLayerSource = void 0;
const react_1 = require("react");
const OLLayerProvider_1 = require("./OLLayerProvider");
function useOLLayerSource() {
    return react_1.useContext(OLLayerProvider_1.OLLayerContext);
}
exports.useOLLayerSource = useOLLayerSource;
//# sourceMappingURL=useOLLayerSource.js.map